import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { IDocumentsConfig } from 'app/core/models/essette-interfaces';

@autoinject()
export class ManageAttachedDocumentCategoriesPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected documentsConfig: IDocumentsConfig = {
        serviceRootUrl: 'um/auths',
        targetType: 'UM.Auths',
    };

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        ...rest: any[]) {
        super(...rest);
    }


    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////

}
